import { connect } from 'react-redux';
import LinkConstructor from './LinkConstructor';
import { actions } from './LinkConstructor.actions';

const LinkConstructorComponent = connect(
    function mapStateToProps(state) {
        return {
            goalEntries: state.goalEntries.list,
            publisherId: state?.user?.publisher?.id || ''
        };
    },
    function mapDispatchToProps(dispatch) {
        return {
            getDataLink: actions.getDataLink
        };
    }
)(LinkConstructor);

export default LinkConstructorComponent;
